import { createIamSessionClient } from "@itaas/core/auth/iam-session.service";
import type { LoginCredentials } from "@itaas/core/auth/auth.types";
import type { AuthSession } from "@itaas/core/auth/models/session.model";
import { resolveTenantSlugFromEmail } from "@itaas/core/identity/utils/resolve-tenant-slug";
import { SUITE_PLATFORM_MODULE_IDS } from "@itaas/core/modules/registry";
import { iamRequest } from "@/api/iam-client";
import { IAM_TENANT_SLUG } from "@/config";

const iam = createIamSessionClient({
  iamRequest,
  tenantSlug: IAM_TENANT_SLUG,
  resolveTenantSlug: (email) =>
    resolveTenantSlugFromEmail(email, IAM_TENANT_SLUG),
  defaultTenantName: "ITaaS Demo",
});

export const suiteSessionApi = iam;

export function suiteAuthLogin(credentials: LoginCredentials): Promise<AuthSession> {
  return iam.login(credentials);
}

export function suiteAuthLogout(): Promise<void> {
  return iam.logout();
}

export function suiteAuthVerifySession(): Promise<AuthSession | null> {
  return iam.verifySession();
}

export function suiteAuthForceRefreshSession(): Promise<AuthSession | null> {
  return iam.forceRefreshSession();
}

export function getLicensedModulesFromSession(session: AuthSession | null): string[] {
  if (!session) return [];
  let modules: string[] = [];
  if (session.licensedModules?.length) {
    modules = session.licensedModules;
  } else {
    try {
      const token = session.tokens?.accessToken;
      if (!token) return [];
      const segment = token.split(".")[1];
      if (!segment) return [];
      const normalized = segment.replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(atob(normalized)) as Record<string, unknown>;
      modules = Array.isArray(payload.modules) ? (payload.modules as string[]) : [];
    } catch {
      return [];
    }
  }
  return modules.filter((id) => !SUITE_PLATFORM_MODULE_IDS.has(id));
}
